import * as React from "react";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import StatCard from "./StatCard";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Tooltip
} from "@mui/material";
import { useEffect, useState } from "react";
import {
  dashboardApi,
  billUpdate,
  billFreightList,
} from "../../Services/Services";
import PrintIcon from "@mui/icons-material/Print";
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
export default function MainGrid() {
  const [bill, setBill] = useState([]);
  const [totalFreight, setTotalFreight] = useState(0);
  const [totalBill, setTotalBill] = useState(0);
  const [todayFreight, setTodayFreight] = useState(0);
  const [todayBill, setTodayBill] = useState(0);
  const [monthlyFreight, setMonthlyFreight] = useState(0);
  const [monthlyBill, setMonthlyBill] = useState(0);
  const [billPendingFreight, setBillPendingFreight] = useState(0);
  const [billPendingBill, setBillPendingBill] = useState(0);

  const [editableRow, setEditableRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);

  useEffect(() => {
    const dashboardData = async () => {
      const data = await dashboardApi();
      if (data) {
        setBill(data.billing_data);
        setTotalFreight(data.total_freight);
        setTotalBill(data.total_billing);
        setTodayFreight(data.today_freight);
        setTodayBill(data.today_billing);
        setMonthlyFreight(data.current_month_freight);
        setMonthlyBill(data.current_month_billing);
        setBillPendingFreight(data.freight_pending_for_billing);
        setBillPendingBill(data.billing_pending_for_payment);
      }
    };
    dashboardData();
  }, []);

  function formatOnlyDate(dateTimeString, format = "dd-mm-yyyy") {
    const date = new Date(dateTimeString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    if (format === "dd-mm-yyyy") return `${day}-${month}-${year}`;
    else if (format === "yyyy-mm-dd") return `${year}-${month}-${day}`;
    else throw new Error("Unsupported format.");
  }

  const data = [
    {
      title: "Total Freights",
      value: totalFreight,
      interval: "Present",
      trend: "up",
    },
    {
      title: "Today Freights",
      value: todayFreight,
      interval: "Today Freights List",
      trend: "down",
    },
    {
      title: "Monthly Freights",
      value: monthlyFreight,
      interval: "Last 30 days",
      trend: "neutral",
    },
    {
      title: "Bill Pending Freights",
      value: billPendingFreight,
      interval: "Last 30 days",
      trend: "up",
    },
    {
      title: "Total Bills",
      value: totalBill,
      interval: "Total Party Bills",
      trend: "down",
    },
    {
      title: "Today Bills",
      value: todayBill,
      interval: "Today Created Bills",
      trend: "up",
    },
    {
      title: "Monthly Bills",
      value: monthlyBill,
      interval: "Last 30 days",
      trend: "up",
    },
    {
      title: "Payment Pending Bills",
      value: billPendingBill,
      interval: "Party Payment Pending Bills",
      trend: "down",
    },
  ];

  const getInitials = (str) =>
    str
      .split(" ")
      .filter((word) => word)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [rawBillData, setRawBillData] = useState([]);
  const handleEditClick = async (bill_id) => {
    const data = await billFreightList(bill_id);
    if (data) {
      setRawBillData(data.freights || []);
      setOpenEditModal(true);
    }
  };

  // Open edit modal function
  const handleEditModalOpen = (billItem, rowName) => {
    setSelectedBill({
      ...billItem,
      party_name: rowName
    });
    setEditData({
      hisab_amt: billItem.hisab_amt || 0,
      follow_date: billItem.follow_date || "",
      remarks: billItem.remarks || "",
      payment_remarks: billItem.payment_remarks || "",
    });
    setEditModalOpen(true);
  };

  // Save edit data
  const handleSaveEdit = async () => {
    if (!selectedBill) return;

    try {
      await billUpdate(selectedBill.billing_id, {
        follow_date: editData.follow_date === "" ? null : editData.follow_date,
        remarks: editData.remarks,
        payment_remarks: editData.payment_remarks,
        hisab_amt: editData.hisab_amt || 0,
      });

      // Refresh data
      const data = await dashboardApi();
      if (data) {
        setBill(data.billing_data);
      }

      setEditModalOpen(false);
      setSelectedBill(null);
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  // Calculate grand totals
  const calculateGrandTotals = () => {
    let grandTotalAmt = 0;
    let grandPaidAmt = 0;
    let grandHisabAmt = 0;

    bill.forEach((row) => {
      const pendingBills = row.pending_bills || [];
      pendingBills.forEach((billItem) => {
        grandTotalAmt += parseFloat(billItem.total_amount || 0);
        grandPaidAmt += parseFloat(billItem.paid_amount || 0);
        grandHisabAmt += parseFloat(billItem.hisab_amt || 0);
      });
    });

    return {
      grandTotalAmt,
      grandPaidAmt,
      grandHisabAmt,
      grandBalAmt: grandTotalAmt - grandHisabAmt
    };
  };

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard {...card} />
          </Grid>
        ))}
      </Grid>

      {/* Edit Modal Dialog */}
      <Dialog
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Edit Bill Details - {selectedBill?.branch_name === "RAIPUR" ? "SRE" : selectedBill?.branch_name === "BILASPUR" ? "JHT" : "MBR"}/{selectedBill?.billing_id}/{getInitials(selectedBill?.party_name || "")}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Rec Amount"
              type="number"
              value={editData.hisab_amt || ""}
              onChange={(e) => setEditData({ ...editData, hisab_amt: e.target.value })}
              sx={{ mb: 2 }}
              size="small"
            />

            <TextField
              fullWidth
              label="Follow Date"
              type="date"
              value={editData.follow_date || ""}
              onChange={(e) => setEditData({ ...editData, follow_date: e.target.value })}
              sx={{ mb: 2 }}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              fullWidth
              label="Follow Remarks"
              multiline
              rows={3}
              value={editData.remarks || ""}
              onChange={(e) => setEditData({ ...editData, remarks: e.target.value })}
              sx={{ mb: 2 }}
              size="small"
            />

            <TextField
              fullWidth
              label="Payment Remarks"
              multiline
              rows={3}
              value={editData.payment_remarks || ""}
              onChange={(e) => setEditData({ ...editData, payment_remarks: e.target.value })}
              sx={{ mb: 2 }}
              size="small"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditModalOpen(false)}>Cancel</Button>
          <Button onClick={handleSaveEdit} variant="contained" color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      <Card variant="outlined" sx={{ width: "100%" }}>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Bill List
        </Typography>

        <TableContainer sx={{ overflowX: "auto", mt: 2 }}>
          <Table
            size="small"
            sx={{
              tableLayout: "auto",
              minWidth: '100%',
              "& td, & th": {
                textAlign: "center",
                whiteSpace: "nowrap",
                padding: "4px 8px",
                fontSize: "0.8125rem",
                borderBottom: "1px solid #ccc",
              },
            }}
          >
            <TableHead
              sx={{
                "& th": {
                  fontWeight: "bold",
                  color: (theme) =>
                    theme.palette.mode === "dark" ? "#2196f3" : "#333",
                  backgroundColor: (theme) =>
                    theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                },
              }}
            >
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Bill ID</TableCell>
                <TableCell>Bill Date</TableCell>
                <TableCell>No. of Days</TableCell>
                <TableCell>Total Amt</TableCell>
                <TableCell> Hisab Amt</TableCell>
                <TableCell>Rec Amt</TableCell>
                <TableCell>Bal Amt</TableCell>
                <TableCell>Follow Date</TableCell>
                <TableCell>Follow Remarks</TableCell>
                <TableCell>Payment Remarks</TableCell>
                <TableCell sx={{ position: "sticky", right: 0, zIndex: 3 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {bill.length > 0 ? (
                <>
                  {bill.map((row, partyIndex) => {
                    const pendingBills = row.pending_bills || [];
                    
                    // Calculate party totals
                    const partyTotals = pendingBills.reduce((acc, billItem) => {
                      return {
                        totalAmt: acc.totalAmt + parseFloat(billItem.total_amount || 0),
                        paidAmt: acc.paidAmt + parseFloat(billItem.paid_amount || 0),
                        hisabAmt: acc.hisabAmt + parseFloat(billItem.hisab_amt || 0),
                      };
                    }, { totalAmt: 0, paidAmt: 0, hisabAmt: 0 });

                    return (
                      <React.Fragment key={partyIndex}>
                        {pendingBills.map((billItem, billIndex) => {
                          const createdDate = new Date(billItem.created_at);
                          const today = new Date();
                          const diffInDays = Math.floor(
                            (today - createdDate) / (1000 * 3600 * 24)
                          );

                          return (
                            <TableRow
                              key={`${partyIndex}-${billIndex}`}
                              sx={{
                                backgroundColor:
                                  (partyIndex + billIndex) % 2 === 0
                                    ? "#fafafa"
                                    : "#ffffff",
                                '&:hover': {
                                  backgroundColor: '#f5f5f5',
                                },
                              }}
                            >
                              {billIndex === 0 && (
                                <>
                                  <TableCell rowSpan={pendingBills.length + 1}>
                                    {partyIndex + 1}
                                  </TableCell>
                                  <TableCell
                                    rowSpan={pendingBills.length + 1}
                                  >
                                    {row.name}
                                  </TableCell>
                                </>
                              )}
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {billItem.branch_name === "RAIPUR"
                                  ? "SRE"
                                  : billItem.branch_name === "BILASPUR"
                                    ? "JHT"
                                    : "MBR"}
                                /{billItem.billing_id}/{getInitials(row.name)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {formatOnlyDate(billItem.created_at)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {diffInDays + 1}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {parseFloat(billItem.total_amount || 0).toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {parseFloat(billItem.paid_amount || 0).toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {billItem.hisab_amt ? parseFloat(billItem.hisab_amt).toFixed(2) : "0.00"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {(parseFloat(billItem.total_amount || 0) - parseFloat(billItem.hisab_amt || 0)).toFixed(2)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                {billItem.follow_date ? formatOnlyDate(billItem.follow_date) : "-"}
                              </TableCell>
                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                  maxWidth: '200px',
                                  minWidth: '150px',
                                }}
                              >
                                <Tooltip
                                  title={billItem.remarks || "-"}
                                  arrow
                                  placement="top"
                                  enterDelay={500}
                                >
                                  <Box
                                    sx={{
                                      maxHeight: '40px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      padding: '4px',
                                      textAlign: 'left',
                                      wordBreak: 'break-word',
                                      whiteSpace: 'pre-wrap',
                                      fontSize: '0.8rem',
                                      lineHeight: '1.2',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        borderRadius: '4px',
                                      }
                                    }}
                                  >
                                    {billItem.remarks && billItem.remarks.length > 100
                                      ? `${billItem.remarks.substring(0, 100)}...`
                                      : (billItem.remarks || "-")
                                    }
                                  </Box>
                                </Tooltip>
                              </TableCell>

                              <TableCell
                                sx={{
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                  maxWidth: '200px',
                                  minWidth: '150px',
                                }}
                              >
                                <Tooltip
                                  title={billItem.payment_remarks || "-"}
                                  arrow
                                  placement="top"
                                  enterDelay={500}
                                >
                                  <Box
                                    sx={{
                                      maxHeight: '40px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      padding: '4px',
                                      textAlign: 'left',
                                      wordBreak: 'break-word',
                                      whiteSpace: 'pre-wrap',
                                      fontSize: '0.8rem',
                                      lineHeight: '1.2',
                                      cursor: 'pointer',
                                      '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        borderRadius: '4px',
                                      }
                                    }}
                                  >
                                    {billItem.payment_remarks && billItem.payment_remarks.length > 100
                                      ? `${billItem.payment_remarks.substring(0, 100)}...`
                                      : (billItem.payment_remarks || "-")
                                    }
                                  </Box>
                                </Tooltip>
                              </TableCell>

                              <TableCell
                                sx={{
                                  position: "sticky",
                                  right: 0,
                                  zIndex: 3,
                                  backgroundColor:
                                    diffInDays > 10
                                      ? "#ffcccc"
                                      : (partyIndex + billIndex) % 2 === 0
                                        ? "#fafafa"
                                        : "#ffffff",
                                }}
                              >
                                <Stack
                                  direction="row"
                                  spacing={1}
                                  justifyContent="center"
                                >
                                  <Tooltip title="Edit">
                                    <IconButton
                                      size="small"
                                      color="primary"
                                      onClick={() => handleEditModalOpen(billItem, row.name)}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title="View Details">
                                    <IconButton
                                      size="small"
                                      color="info"
                                      onClick={() =>
                                        handleEditClick(billItem.billing_id)
                                      }
                                    >
                                      <VisibilityIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </Stack>
                              </TableCell>
                            </TableRow>
                          );
                        })}

                        {/* Party Total Row */}
                        <TableRow
                          sx={{
                            backgroundColor: "#e3f2fd",
                            fontWeight: "bold",
                          }}
                        >
                          <TableCell colSpan={3} align="right">
                            <strong>Total</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{partyTotals.totalAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{partyTotals.paidAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{partyTotals.hisabAmt.toFixed(2)}</strong>
                          </TableCell>
                          <TableCell>
                            <strong>{(partyTotals.totalAmt - partyTotals.hisabAmt).toFixed(2)}</strong>
                          </TableCell>
                          <TableCell colSpan={4} />
                        </TableRow>
                      </React.Fragment>
                    );
                  })}

                  {/* Grand Total Row */}
                  {(() => {
                    const grandTotals = calculateGrandTotals();
                    return (
                      <TableRow
                        sx={{ backgroundColor: "#d0f0c0", fontWeight: "bold" }}
                      >
                        <TableCell colSpan={5} align="right">
                          <strong>Grand Total</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{grandTotals.grandTotalAmt.toFixed(2)}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{grandTotals.grandPaidAmt.toFixed(2)}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{grandTotals.grandHisabAmt.toFixed(2)}</strong>
                        </TableCell>
                        <TableCell>
                          <strong>{grandTotals.grandBalAmt.toFixed(2)}</strong>
                        </TableCell>
                        <TableCell colSpan={4} />
                      </TableRow>
                    );
                  })()}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={13} align="center">
                    No records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Dialog
          open={openEditModal}
          onClose={() => setOpenEditModal(false)}
          PaperProps={{
            style: {
              width: "1200px",
              height: "600px",
              maxWidth: "90%",
              overflow: "auto",
            },
          }}
        >
          <DialogContent>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setOpenEditModal(false)}
              sx={{ height: "35px", marginRight: "10px" }}
            >
              Close
            </Button>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table
                stickyHeader
                size="small"
                sx={{
                  tableLayout: "auto",
                  "& td, & th": {
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    padding: "4px 8px",
                    fontSize: "0.8125rem",
                    borderBottom: "1px solid #ccc",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        fontWeight: "bold",
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    <TableCell>SR. No</TableCell>
                    <TableCell>Freight Id</TableCell>
                    <TableCell>Party Name</TableCell>
                    <TableCell>Branch Name</TableCell>
                    <TableCell>Loading Date</TableCell>
                    <TableCell>Unloading Date</TableCell>
                    <TableCell>Truck No.</TableCell>
                    <TableCell>D.O. No.</TableCell>
                    <TableCell>T.P. No.</TableCell>
                    <TableCell>From</TableCell>
                    <TableCell>To</TableCell>
                    <TableCell>Loading Wt</TableCell>
                    <TableCell>Receiving Wt</TableCell>
                    <TableCell>Shortage Wt</TableCell>
                    <TableCell>Billing Wt</TableCell>
                    <TableCell>Freight Rate</TableCell>
                    <TableCell>Freight Amt</TableCell>
                    <TableCell>TDS %</TableCell>
                    <TableCell>TDS Amt</TableCell>
                    <TableCell>Shortage Rate</TableCell>
                    <TableCell>Shortage Amt</TableCell>
                    <TableCell>Ad Mines</TableCell>
                    <TableCell>Ad Diesel</TableCell>
                    <TableCell>Ad Cash</TableCell>
                    <TableCell>Total Ad</TableCell>
                    <TableCell>Commission</TableCell>
                    <TableCell>Net Amt</TableCell>
                    <TableCell>Others Exp.</TableCell>
                    <TableCell>Net Payable</TableCell>
                    <TableCell>Truck Owner</TableCell>
                    <TableCell>Phone No.</TableCell>
                    <TableCell>PAN No.</TableCell>
                    <TableCell>Remark</TableCell>

                    <TableCell>Paid Amt</TableCell>
                    <TableCell>Bal Amt</TableCell>
                    <TableCell>Ref. No</TableCell>
                    <TableCell>Pay Id</TableCell>
                    <TableCell>Biil Date</TableCell>

                    <TableCell>Rec Amt</TableCell>
                    <TableCell>Diff Amt</TableCell>
                    <TableCell>Payment Remark</TableCell>
                    <TableCell>Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rawBillData.map((row, index) => (
                    <TableRow
                      key={row.freight_id}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                      }}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.freight_id}</TableCell>
                      <TableCell>{row.party_name}</TableCell>
                      <TableCell>{row.branch_name}</TableCell>
                      <TableCell>{row.loading_date}</TableCell>
                      <TableCell>{row.unloading_date}</TableCell>
                      <TableCell>{row.truck_no}</TableCell>
                      <TableCell>{row.do_no}</TableCell>
                      <TableCell>{row.tp_no}</TableCell>
                      <TableCell>{row.from_location}</TableCell>
                      <TableCell>{row.to_location}</TableCell>
                      <TableCell>{row.loading_wt}</TableCell>
                      <TableCell>{row.received_wt}</TableCell>
                      <TableCell>{row.shortage_wt}</TableCell>
                      <TableCell>{row.billing_wt}</TableCell>
                      <TableCell>{row.freight_rate}</TableCell>
                      <TableCell>{row.freight_amt}</TableCell>
                      <TableCell>{row.tds_per}</TableCell>
                      <TableCell>{row.tds_amt}</TableCell>
                      <TableCell>{row.shortage_rate}</TableCell>
                      <TableCell>{row.shortage_amt}</TableCell>
                      <TableCell>{row.ad_mines_exp}</TableCell>
                      <TableCell>{row.ad_diesel_exp}</TableCell>
                      <TableCell>{row.ad_cash_exp}</TableCell>
                      <TableCell>{row.total_advance}</TableCell>
                      <TableCell>{row.commission}</TableCell>
                      <TableCell>{row.net_amount}</TableCell>
                      <TableCell>{row.other_exp}</TableCell>
                      <TableCell>{row.net_payable}</TableCell>
                      <TableCell>{row.truck_owner}</TableCell>
                      <TableCell>{row.phone_no}</TableCell>
                      <TableCell>{row.pan_no}</TableCell>
                      <TableCell>{row.remark}</TableCell>

                      <TableCell>{row.paid_amount.toFixed(1)}</TableCell>
                      <TableCell>{row.bal_amount.toFixed(1)}</TableCell>

                      <TableCell>
                        {row.billing?.branch_name
                          ? `${row.billing.branch_name === "RAIPUR"
                            ? "SRE"
                            : row.billing.branch_name === "BILASPUR"
                              ? "JHT"
                              : "MBR"
                          }/${row.billing.billing_id}/${getInitials(
                            row.billing.party_name
                          )}`
                          : "-"}
                      </TableCell>

                      <TableCell>
                        {row.freight_pay_ids && row.freight_pay_ids.length > 0
                          ? row.freight_pay_ids.join(", ")
                          : "-"}
                      </TableCell>

                      <TableCell>
                        {row.billing
                          ? formatOnlyDate(row.billing.created_at)
                          : ""}
                      </TableCell>

                      <TableCell className="no-print">
                        {row.receive_amount.toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.difference_amount.toFixed(1)}
                      </TableCell>
                      <TableCell className="no-print">
                        {row.payment_remark}
                      </TableCell>
                      <TableCell>{formatOnlyDate(row.created_at)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
        </Dialog>
      </Card>
    </Box>
  );
}